import { render, staticRenderFns } from "./participantSearchInfo.vue?vue&type=template&id=b6afbc9a"
import script from "./participantSearchInfo.vue?vue&type=script&lang=js"
export * from "./participantSearchInfo.vue?vue&type=script&lang=js"
import style0 from "./participantSearchInfo.vue?vue&type=style&index=0&id=b6afbc9a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports